/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type PrioritiesPageWrapper from '@jira/admin-pages__priorities/src/PrioritiesPageWrapper.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyPrioritiesPage: LazyComponent<typeof PrioritiesPageWrapper> = lazyForPaint(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-admin-pages-priorities", jiraSpaEntry: "async-admin-pages-priorities" */ '@jira/admin-pages__priorities/src/PrioritiesPageWrapper.tsx'
		),
	),
);

const PrioritiesPage = (): React.JSX.Element => (
	<LazyPage Page={LazyPrioritiesPage} pageId="jira-admin-pages-priorities" shouldShowSpinner />
);

export default PrioritiesPage;
